// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
// However where nodejs readline diverges, they are adjusted to conform to it
module.exports = {
  nomod: {
    escape: "\x1B",
    space: ' ' // actually '\u0020'

  },
  ctrl: {
    ' ': "\0",
    'a': "\x01",
    'b': "\x02",
    'c': "\x03",
    'd': "\x04",
    'e': "\x05",
    'f': "\x06",
    'g': "\x07",
    'h': "\b",
    'i': "\t",
    'j': "\n",
    'k': "\x0B",
    'm': "\f",
    'n': "\r",
    'l': "\x0E",
    'o': "\x0F",
    'p': "\x10",
    'q': "\x11",
    'r': "\x12",
    's': "\x13",
    't': "\x14",
    'u': "\x15",
    'v': "\x16",
    'w': "\x17",
    'x': "\x18",
    'y': "\x19",
    'z': "\x1A",
    '[': "\x1B",
    '\\': "\x1C",
    ']': "\x1D",
    '^': "\x1E",
    '_': "\x1F",
    'space': "\0"
  }
};